// extracted by mini-css-extract-plugin
export default {"burgerButton":"BurgerMenuDesktop_burgerButton__5dygE","burger":"BurgerMenuDesktop_burger__6kJeS","line":"BurgerMenuDesktop_line__Y5Frx"};